module.exports = __webpack_public_path__ + "assets/img/33_168_big.2eec1909.jpg";